import { TaskSleepButton } from "../components/TaskSleepButton"
import type { ProductModule, TaskLifecycleControlProps } from "./types"

function SleepTaskLifecycleControl({ taskModel, onSlept }: TaskLifecycleControlProps): JSX.Element | null {
    if (!onSlept || taskModel.isClosed) return null
    return <TaskSleepButton taskModel={taskModel} onSlept={onSlept} />
}

export const sleepModule: ProductModule = {
    id: "sleep",
    taskLifecycleControls: [
        {
            component: SleepTaskLifecycleControl,
            isVisible: ({ taskModel, onSlept }) => Boolean(onSlept) && !taskModel.isClosed,
        },
    ],
}
